import React from 'react'
import { IntegracionAccordionDocumentacion } from '../../ingreso/IntegracionAccordionDocumentacion';

export const DocumentacionIntegracionMenu = ({disabled}) => {
  const [datosCompletosDocumentacion, setDatosCompletosDocumentacion] =
    React.useState(false);

  return (
    <>
      <IntegracionAccordionDocumentacion
        disabled={disabled}
        datosCompletos={datosCompletosDocumentacion}
        setDatosCompletos={setDatosCompletosDocumentacion}
        autogestion={false}
      />
    </>
  )
}
